import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IMovieIconProps extends IConDefaultType {}

function MovieIcon({ className, size = 24, rotate, flip, color = '#8A8A8A' }: IMovieIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4H16C18.2091 4 20 5.79086 20 8V16C20 18.2091 18.2091 20 16 20H8C5.79086 20 4 18.2091 4 16V8C4 5.79086 5.79086 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8ZM10.2631 8.11603C9.59647 7.73113 8.76314 8.21225 8.76314 8.98205V15.0442C8.76314 15.814 9.59647 16.2952 10.2631 15.9103L15.5131 12.8792C16.1798 12.4943 16.1798 11.532 15.5131 11.1471L10.2631 8.11603Z"
          fill={color}
        />
      </svg>
    </i>
  );
}

export default MovieIcon;
